<template>
    <div class="content">
        <pageTool></pageTool>
        <Header
            :page-title="title"
        ></Header>
        <topNav2
            :nav-config="navConfig"
            @navClick="navClick"
        ></topNav2>
        <infoCard
            :list-data="demandList0"
            @cardEvent="handleCardEvent"
        ></infoCard>
    </div>
</template>

<script>
import Header from "@/components/SNInfo/Header"
import topNav2 from "@/components/nav/topNav2"
import pageTool from "@/components/nav/pageTool"
import infoCard from "@/components/card/infoCard"
import {onMounted, reactive} from "@vue/runtime-dom"
import {getProcessList} from "@/api/policy"
import {useRouter} from "vue-router"
const banner = require('@/assets/img/page_banner_1.png')
const icon0 = require('@/assets/img/business_1.png')
const icon1 = require('@/assets/img/icon0.png')
const icon2 = require('@/assets/img/icon10.png')
export default {
    name: "FinancialServices",
    setup() {
        const router = useRouter()
        const title = {
            cn: '金融服务',
            en: 'FINANCIAL SERVICES',
            hasSearch: true,
            titleStyle: false,
            banner
        }
        const navConfig = [
            {name: '产权证办理', icon: icon0},
            {name: '信贷服务', icon: icon1},
            // {name: '农业保险', icon: icon2},
        ]
        const demandList0 = reactive({
            title: '农业保险',
            secId: 300012,
            list: []
        })
        const handleCardEvent = (evt) => {
            router.push({ name: 'PCP', query: {params: evt.secId + '&' + evt.id}})
        }
        const initList = () => {
            const params = {"current": 1,"model": {"secondCategoryId": 300012}, "size": 200}
            getProcessList(params).then(res => {
                const list = res.records.map(k => ({
                    id: k.id,
                    date: k.createTime,
                    title: k.title,
                }))
                demandList0.list = list
            })
        }
        const navClick = (i) => {
            if (i == 1) {
                router.push({ name: 'CreditService'})
            } else if (i == 0) {
                router.push({ name: 'PCP', query: {params: '200022&1372795182163951616'}})
            }
        }
        onMounted(() => {
            initList()
        })
        return {
            title,
            navConfig,
            demandList0,
            navClick,
            handleCardEvent
        }
    },
    components: {
        Header,
        topNav2,
        infoCard,
        pageTool
    }
}
</script>

<style scoped lang="stylus">
    .content {
        width 100%
        height 100%
        background #FFF
    }
</style>